/* eslint-disable */
export default {
  url: process.env.REACT_APP_API || 'http://release-tool.local'
}
